/********************************************************************************
 * Copyright (c) 2020 Cedalo AG
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
'use strict';

module.exports = class GatewayAPI {
	constructor(logger) {
		this._logger = logger;
	}

	get logger() {
		return this._logger;
	}
};



// WEBPACK FOOTER //
// ../gateway-client/src/client/apis/GatewayAPI.js